"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _getIcon;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconUI = void 0;
const iconId = 'kukai-icon';
class IconUI {
    constructor() {
        _getIcon.set(this, () => {
            return document.getElementById(iconId);
        });
    }
    async init(cb, styleClass) {
        var _a;
        if (!this.isInit) {
            let icon = document.createElement('button');
            icon.id = iconId;
            let k = document.createElement('img');
            k.style.width = '60px';
            k.style.height = '60px';
            k.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEhQTFRF0dH/amn+urn/o6L+8/P/U1L+9PP/Xl3+mJf+3dz/gYD+3Nz/xcX/jIz+jIv+o6P/dXT+urr/xsX/6Oj/r67/////R0b+////pIBhiAAAABh0Uk5T//////////////////////////////8AzRMu6gAAAaZJREFUeNqsl9uSgyAMhgNyUNS2eyB9/zddXHW1QAKW/ccrhm8MSUgCPAkpkN2vJChqD2RBOVs8yc5SVcLgMCMHFbC0SMjKAgwCGQlgYNVjQb2i4FFgUWLMw5PGCukpB0uslEzhavZE7/CEFzS9wqO+AuvxDCuBlyTUCe7xovoDBrws+IMTox/Rin3EPhE7HEdJD94P59037/0tE68Fju9RH/b6/pX1Jr5jK5ycGJbN8Mp6nzl1+BwPu5VNfuEWWCELC/PLmjQTVIAlC9NscBk8Zw5mWJwDbBl4CRrFBn+DQhpm2XBoABousAggafiDZ1FCR8Irm+TloY6GN9YPb8CH7i2wF2/B5pM1nIWN0F+c4R0ZqjVGjjNckkmyxZczHMj03HLDGtpwxV+MvSZlDbelKxk0UIbPxWIQyjCVKrJchhC/CcNVRQFEbbIV0FWV3j3Yj1zpTfwdw1vg77min7gs7hgofLxytJu40WmIehXeTLwi6BYrYtfquG/C/zT3trGiaaBpG6Xahri28bFtcG0bmduG9bZnQuMDpfFp1Pgoq38O/ggwACoyIQpeKqtUAAAAAElFTkSuQmCC';
            icon.innerHTML = k.outerHTML;
            if (styleClass) {
                icon.className = styleClass;
            }
            else {
                icon.style.width = '60px';
                icon.style.height = '60px';
                icon.style.bottom = '40px';
                icon.style.left = '40px';
                icon.style.position = 'fixed';
                icon.style.borderRadius = '50px';
                icon.style.boxShadow = '2px 2px 3px #999';
                icon.style.padding = '0';
                icon.style.border = '0';
            }
            icon.style.zIndex = '99998';
            icon.style.display = 'none';
            document.body.appendChild(icon);
            (_a = __classPrivateFieldGet(this, _getIcon).call(this)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', cb);
        }
        else {
            throw new Error("Kukai-Embed Already Present");
        }
    }
    get isInit() {
        return !!__classPrivateFieldGet(this, _getIcon).call(this);
    }
    deinit() {
        const i = __classPrivateFieldGet(this, _getIcon).call(this);
        if (i) {
            document.body.removeChild(i);
        }
    }
    show() {
        const i = __classPrivateFieldGet(this, _getIcon).call(this);
        if (i) {
            i.style.display = 'block';
        }
    }
    hide() {
        const i = __classPrivateFieldGet(this, _getIcon).call(this);
        if (i) {
            i.style.display = 'none';
        }
    }
}
exports.IconUI = IconUI;
_getIcon = new WeakMap();
